/* eslint-disable no-useless-escape */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/**
 * 错误类型列举
 * 10001    字段名错误(未包含在搜索字段与分析字段中)
 * 10002    字段嵌套(父表达式为字段表达式，子表达式中包含字段表达式)
 * 10003    字段与所在的父表达式字段不匹配
 * 10004    特殊字符格式错误(\  后面跟 空格|括号|空  报错)
 * 20001    逻辑词开头
 * 20002    逻辑词连接
 * 20003    逻辑词结尾
 * 20004    逻辑词个数超限（最大限制1024）
 * 30001    值为空
 * 30002    缺少 ）
 * 30003    多余 ）
 * 30004    缺少 ]
 * 30005    多余 ]
 * 30006    缺少 "
 * 30007    缺少 '
 * 30008    缺少 |
 * 40001    占位符格式错误
 * 40002    频率符格式错误
 * 40003    占位符打到15个上限
 * 40004    频率符个数超50上限
 * 40005    同句同段匹配符语法错误（前后两个表达式中不能包含字段表达式）
 * 50001    []格式不正确
 * 50002    []时间格式错误
 * 50003    []时间大小错误， 开始值应小于结束值
 * 50004    []数字范围格式错误
 * 50005    []数字大小错误，开始值应小于结束值
 * 60001    字段表达式格式错误
 * 70001    特殊检索式格式错误 [SEMANTIC|BULK]xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx 32位随机数 8-4-4-4-12 || [BIO]xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx 32位随机数 || [PHARM]xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx 32位随机数 || [SYNAPSE]xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx 32位随机数 || [CAS]xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx 32位随机数 || [CAS_MARKUSH]xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx 32位随机数
 * 70002    特殊检索式存在多个
 * 70004    字段使用方式错误，请将文件夹路径放在||内
 * 70005    请将层级字段、选项字段的标引值放在""内
 * 70006    請將not blank放在""內
 * 80001    R命令只能使用AND连接
 * 80002    R命令存在多个
 * 80003    R命令位置只能放在开头
 */
import {
    last,
    forEach,
    includes,
    concat,
    get,
    startsWith,
    endsWith,
    find,
    findLast,
    toNumber,
    max,
    filter,
    cloneDeep,
} from 'lodash';
import {
    isDateValue,
    isIntegerValue,
    isCorrectRange,
    isCorrectClassification,
    isStartStrSame,
    checkHasFieldExp,
} from '../utils/validationUtils.js';
import {
    getFieldList,
    DATE_TYPE_FIELDS,
    RANGE_TYPE_FIELDS,
    SUPPORT_TREE_FIELDS,
    MAX_LOGIC_LIMIT,
    MAX_PLACE_SYMBOL_LIMIT,
    MAX_FREQ_LIMIT,
    RANGE_CLASSIFICATION_FIELDS,
    WORKSPACE_FIELDS,
} from '../config/index';
import {
    TOKEN_TYPE_OPERATOR,
    TOKEN_TYPE_PLACESYMBOL,
    TOKEN_TYPE_FREQUENCY,
    TOKEN_TYPE_SPACE,
    TOKEN_TYPE_USER,
    TOKEN_TYPE_LOGIC,
    EXPRESSION_TYPE_FIELD,
    EXPRESSION_TYPE_FIELD_R,
    EXPRESSION_TYPE_OPERATOR,
    EXPRESSION_TYPE_RANGE,
    EXPRESSION_TYPE_TOKEN,
    TOKEN_TYPE_FIELD,
    TOKEN_TYPE_FIELD_R,
    TOKEN_TYPE_TREE,
    TOKEN_TYPE_SPECIALQUERY,
    TOKEN_TYPE_SPECIAL_SYMBOL,
    SPECIAL_SYMBOL_NOT_SUPPORT_TOKEN_TYPE,
    TOKEN_TYPE_SEN_PARA,
    TOKEN_TYPE_WORKSPACE,
    LOGIC_OPERATOR_AND,
    SUPPORT_NEST_FIELDS,
} from '../../constants';
import Token from './Token.js';
import searchFieldsService from '../service/searchFieldsService';

export default {
    errorData: {},
    currentExp: {},
    parentExp: {},
    ExpressionList: [],
    TokenList: [],
    getExpressionError(currentExp, ExpressionList, TokenList, isRDVersion = false) {
        this.errorData = {};
        this.currentExp = currentExp;
        if (ExpressionList && ExpressionList.length > 0) {
            this.ExpressionList = ExpressionList;
            this.parentExp = last(ExpressionList);
        }
        if (TokenList && TokenList.length) {
            this.TokenList = TokenList;
        }
        this.validateToken(isRDVersion);
        this.validateExpression();
        this.validateLogic();
        this.currentExp.errorData = this.errorData;
        return this.currentExp;
    },
    /**
   * 验证表达式错误
   */
    validateExpression() {
        const { children } = this.currentExp;
        const errorData = {
            id: this.currentExp.id,
        };
        const expressionError = [];
        const patnetFieldTokenType = get(this.parentExp, 'children[0].data.type', '');
        const patentField = patnetFieldTokenType === TOKEN_TYPE_FIELD ? get(this.parentExp, 'children[0].data.value', '').toLocaleUpperCase() : '';
        // eslint-disable-next-line no-shadow
        const max = this.getPlaceSymbolCount(children);
        if (max > MAX_PLACE_SYMBOL_LIMIT) {
            expressionError.push({
                id: this.currentExp.id,
                errorCode: '40003',
            });
        }
        if (this.currentExp.expressionType === EXPRESSION_TYPE_OPERATOR) {
            /* 工作空间和自定义字段特殊处理逻辑，没办法根据()内部的值特殊切词一个类型，所以特殊处理一下
            * 其实不止自定义字段类型，如日期错误，加了空格也不行
            * start */
            const prevExp = last(cloneDeep(get(this.parentExp, 'children', [])));
            const prevExpType = get(prevExp, 'expressionType');
            let fieldExpValue;
            if (prevExpType !== EXPRESSION_TYPE_TOKEN && prevExpType === EXPRESSION_TYPE_FIELD) {
                fieldExpValue = get(prevExp, 'children[0].data.value');
            }
            /* end */
            if (last(children).expressionType !== EXPRESSION_TYPE_TOKEN || last(children).data.value !== ')') {
                //  缺少小括号和中括号作为token 错误
                // errorData.errorCode = '30002';
            } else if (children.length === 2 || (children.length === 3 && get(children[1], 'data.type') === TOKEN_TYPE_SPACE)) {
                errorData.errorCode = '30001';
            } else if (includes(WORKSPACE_FIELDS, fieldExpValue || patentField)) {
                const workspaceToken = find(children, (child) => get(child, 'data.type') === TOKEN_TYPE_WORKSPACE);
                if (!workspaceToken) {
                    errorData.errorCode = '70004';
                }
                if (workspaceToken && !startsWith(workspaceToken.data.value, '|')) {
                    errorData.errorCode = '30008';
                }
            } else if (startsWith(fieldExpValue || patentField, 'CCF_')) {
                const allCustomFields = searchFieldsService.searchFields;
                const fieldInfo = find(allCustomFields, (field) => get(field, 'name') === patentField);
                const fieldType = get(fieldInfo, 'type');
                if (fieldType !== 'STRING') {
                    // 层级value带 '\' 的值，识别为TOKEN_TYPE_SPECIAL_SYMBOL
                    const userTokenList = children.filter((item) => {
                        const type = get(item, 'data.type');
                        return type === TOKEN_TYPE_USER || type === TOKEN_TYPE_SPECIAL_SYMBOL;
                    });

                    const illegal = userTokenList.some((item) => {
                        const value = get(item, 'data.value', '');
                        return value && !startsWith(value, '"');
                    });
                    if (illegal) {
                        errorData.errorCode = fieldType === 'URL' ? '70006' : '70005';
                    }
                }
            }
        } else if (this.currentExp.expressionType === EXPRESSION_TYPE_RANGE) {
            if (last(children).expressionType !== EXPRESSION_TYPE_TOKEN || last(children).data.value !== ']') {
                //  缺少小括号和中括号作为token 错误
                // errorData.errorCode = '30004';
            } else if (children.length === 2 || (children.length === 3 && get(children[1], 'data.type') === TOKEN_TYPE_SPACE)) {
                errorData.errorCode = '30001';
            } else {
                const rangeTokenList = this.getRangeTokenList(children);
                const customFieldDateTypeFields = searchFieldsService.dateTypeFieldList;
                const customFieldNumTypeFields = searchFieldsService.numTypeFieldList;
                // 如果这里有问题，建议弄一个class，通过get去拼接DATE_TYPE_FIELDS和自定义字段的类型
                if (includes(DATE_TYPE_FIELDS, patentField)
                || includes(RANGE_TYPE_FIELDS, patentField)
                || includes(RANGE_CLASSIFICATION_FIELDS, patentField)
                || includes(customFieldDateTypeFields, patentField)
                || includes(customFieldNumTypeFields, patentField)
                ) {
                    if (rangeTokenList.length !== 3
            || !get(rangeTokenList[0], 'data')
            || !get(rangeTokenList[2], 'data')
            || get(rangeTokenList, '[1].data.value').toLocaleUpperCase() !== 'TO') {
                        errorData.errorCode = '50001';
                    } else {
                        this.validateRangeToken(rangeTokenList, patentField);
                    }
                }
            }
        } else if (this.currentExp.expressionType === EXPRESSION_TYPE_FIELD) {
            const field = get(children[0], 'data.value', '').toLocaleUpperCase();
            const value = get(children[2], 'data.value', '') || get(children, 'value', '');
            //  匹配出表达式中的值进行合法性校验
            const realValueArr = value.match(/[^()\s]+/g);
            if (!realValueArr) return;
            if (includes(DATE_TYPE_FIELDS, field)) {
                if (last(children).expressionType !== EXPRESSION_TYPE_RANGE) {
                    if (realValueArr.length > 1 || !isDateValue(realValueArr[0])) {
                        errorData.errorCode = '50002';
                    }
                }
            }
            if (includes(RANGE_TYPE_FIELDS, field)) {
                if (last(children).expressionType !== EXPRESSION_TYPE_RANGE) {
                    if (realValueArr.length > 1 || !isIntegerValue(realValueArr[0])) {
                        errorData.errorCode = '50004';
                    }
                }
            }
        }
        if (errorData.errorCode) {
            expressionError.push(errorData);
        }
        if (expressionError.length > 0) {
            this.errorData.expressionError = expressionError;
        }
    },
    /**
   * 验证token错误
   */
    validateToken(isRDVersion = false) {
        const tokenError = [];
        const isNotSupportedFieldNest = this.getIsNotSupportedFieldNest();
        forEach(this.currentExp.children, (item, index) => {
            if (item.expressionType === EXPRESSION_TYPE_TOKEN) {
                const errData = {
                    id: item.data.id,
                };
                if (item.data.type === TOKEN_TYPE_FIELD) {
                    if (!includes(getFieldList(isRDVersion), item.data.value.toLocaleUpperCase())) {
                        errData.errorCode = '10001';
                        tokenError.push(errData);
                    } else if (isNotSupportedFieldNest) {
                        errData.errorCode = '10002';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_PLACESYMBOL
            && !/^\$(W(\d+|S)$)|(PRE\d+$)/.test(item.data.value.toLocaleUpperCase())) {
                    errData.errorCode = '40001';
                    tokenError.push(errData);
                } else if (item.data.type === TOKEN_TYPE_FREQUENCY) {
                    if (!/^\$(FREQ\d+$)/.test(item.data.value.toLocaleUpperCase())) {
                        errData.errorCode = '40002';
                    } else {
                        const freqCount = get(item.data.value.match(/\d+/), '0');
                        if (freqCount > MAX_FREQ_LIMIT) {
                            errData.errorCode = '40004';
                        }
                    }
                    if (errData.errorCode) {
                        tokenError.push(errData);
                    }
                } else if (item.data.value === '(' && get(last(this.currentExp.children), 'data.value') !== ')') {
                    errData.errorCode = '30002';
                    tokenError.push(errData);
                } else if (item.data.value === ')' && (index !== this.currentExp.children.length - 1 || get(this.currentExp, 'children[0].data.value') !== '(')) {
                    errData.errorCode = '30003';
                    tokenError.push(errData);
                } else if (item.data.value === '[' && (get(last(this.currentExp.children), 'data.value') !== ']')) {
                    errData.errorCode = '30004';
                    tokenError.push(errData);
                } else if (item.data.value === ']' && (index !== this.currentExp.children.length - 1 || get(this.currentExp, 'children[0].data.value') !== '[')) {
                    errData.errorCode = '30005';
                    tokenError.push(errData);
                } else if (item.data.type === TOKEN_TYPE_USER) {
                    if (/^"\s*"$|^'\s*'$/.test(item.data.value)) {
                        errData.errorCode = '30001';
                        tokenError.push(errData);
                    } else if (startsWith(item.data.value, '"') && !endsWith(item.data.value, '"') || item.data.value === '"') {
                        errData.errorCode = '30006';
                        tokenError.push(errData);
                    } else if (startsWith(item.data.value, "'") && !endsWith(item.data.value, "'") || item.data.value === "'") {
                        errData.errorCode = '30007';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_TREE) {
                    const parentExpType = get(this.parentExp, 'expressionType');
                    const parentExpField = get(this.parentExp, 'children.0.data.value', '').toLocaleUpperCase();
                    if (parentExpType !== EXPRESSION_TYPE_FIELD || !includes(SUPPORT_TREE_FIELDS, parentExpField)) {
                        errData.errorCode = '10003';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_SPECIALQUERY) {
                    const isMultiple = this.getIsMultipleSpecialQuery(TOKEN_TYPE_SPECIALQUERY);
                    const specialQueryReg = /\[(SEMANTIC|BULK|CHEM)\](an-)?[a-zA-Z0-9]{8}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{4}\-[a-zA-Z0-9]{12}/;
                    const bioQueryReg = /\[(BIO)\][a-zA-Z0-9]{32}/;
                    const pharmQueryReg = /\[(PHARM)\][a-zA-Z0-9]{32}/;
                    const synapseQueryReg = /\[(SYNAPSE)\][a-zA-Z0-9]{32}/;
                    const casQueryReg = /\[(CAS)\][a-zA-Z0-9]{32}/;
                    const casMarkushQueryReg = /\[(CAS_MARKUSH)\][a-zA-Z0-9]{32}/;
                    //   特殊检索式不在最前
                    if (isMultiple) {
                        errData.errorCode = '70002';
                        tokenError.push(errData);
                    } else if (!specialQueryReg.test(item.data.value) && !bioQueryReg.test(item.data.value) && !pharmQueryReg.test(item.data.value) && !synapseQueryReg.test(item.data.value) && !casQueryReg.test(item.data.value) && !casMarkushQueryReg.test(item.data.value)) {
                        errData.errorCode = '70001';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_FIELD_R) {
                    const isMultiple = this.getIsMultipleSpecialQuery(TOKEN_TYPE_FIELD_R);
                    const isNotStart = this.isNotSpecialStart(item.data);
                    if (isMultiple) {
                        errData.errorCode = '80002';
                        tokenError.push(errData);
                    } else if (isNotStart) {
                        errData.errorCode = '80003';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_LOGIC
            && item.data.value.toLocaleUpperCase() !== LOGIC_OPERATOR_AND
            && get(this.currentExp, `children[${index - 2}].expressionType`) === EXPRESSION_TYPE_FIELD_R) {
                    errData.errorCode = '80001';
                    tokenError.push(errData);
                } else if (item.data.type === TOKEN_TYPE_SPECIAL_SYMBOL) {
                    const hasNextToken = !!get(this.currentExp, `children[${index + 1}]`);
                    const nextTokenType = get(this.currentExp, `children[${index + 1}].data.type`);

                    // 递归查找字段名
                    const getFieldName = (exp) => {
                        if (!exp) return null;
                        if (exp.expressionType === EXPRESSION_TYPE_FIELD) {
                            return get(exp, 'children[0].data.value');
                        }
                        const children = get(exp, 'children', []);
                        return children.reduce((result, child) => {
                            if (result) return result;
                            const fieldName = getFieldName(child);
                            return fieldName || null;
                        }, null);
                    };

                    // 获取当前字段名
                    const currentExpFieldName = getFieldName(this.parentExp);

                    /* 自定义字段类型的特殊判断 */
                    const prevExp = last(cloneDeep(get(this.parentExp, 'children', [])));
                    const prevExpType = get(prevExp, 'expressionType');
                    let fieldExpValue;
                    if (prevExpType !== EXPRESSION_TYPE_TOKEN && prevExpType === EXPRESSION_TYPE_FIELD) {
                        fieldExpValue = get(prevExp, 'children[0].data.value');
                    }

                    if ((includes(SPECIAL_SYMBOL_NOT_SUPPORT_TOKEN_TYPE, nextTokenType) || !hasNextToken) && !startsWith(currentExpFieldName || fieldExpValue, 'CCF_')) {
                        errData.errorCode = '10004';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_SEN_PARA) {
                    const prevExp = get(this.currentExp, `children[${index - 2}]`);
                    const nextExp = get(this.currentExp, `children[${index + 2}]`);
                    const hasFieldExp = checkHasFieldExp([prevExp, nextExp]);
                    if (hasFieldExp) {
                        errData.errorCode = '40005';
                        tokenError.push(errData);
                    }
                } else if (item.data.type === TOKEN_TYPE_WORKSPACE) {
                    if (startsWith(item.data.value, '|') && !endsWith(item.data.value, '|') || item.data.value === '|') {
                        errData.errorCode = '30008';
                        tokenError.push(errData);
                    }
                }
            }
        });
        if (tokenError.length > 0) {
            this.errorData.tokenError = concat(this.errorData.tokenError || [], tokenError);
        }
    },
    /**
   * 验证逻辑词错误
   */
    validateLogic() {
        let chainStr = '';
        const startLogicReg = /^_*l/; // 逻辑词开头
        const continuousLogicReg = /l_l/; // 逻辑词连接
        const endLogicReg = /l_*$/; // 逻辑词结尾
        const logicError = [];
        const autoLogicTypeList = [TOKEN_TYPE_USER, EXPRESSION_TYPE_FIELD, EXPRESSION_TYPE_OPERATOR];
        const { children } = this.currentExp;
        forEach(children, (item, index) => {
            let chianItem;
            const type = get(item, 'data.type');
            const expressionType = get(item, 'expressionType');
            const prevType = get(children[index - 1], 'data.type') || get(children[index - 1], 'expressionType');
            const nextType = get(children[index + 1], 'data.type') || get(children[index + 1], 'expressionType');
            if (expressionType === EXPRESSION_TYPE_TOKEN) {
                chianItem = type;
                if (type === TOKEN_TYPE_LOGIC) {
                    chianItem = 'l';
                } else if (type === TOKEN_TYPE_SPACE || type === TOKEN_TYPE_OPERATOR) {
                    chianItem = '_';
                    /**
           * 如果当未空格，且前后类型包含在 TOKEN_TYPE_USER, EXPRESSION_TYPE_FIELD, EXPRESSION_TYPE_OPERATOR中时
           * 默认会补充逻辑词
           */
                    if (type === TOKEN_TYPE_SPACE && includes(autoLogicTypeList, prevType) && includes(autoLogicTypeList, nextType)) {
                        chianItem = 'l';
                    }
                } else {
                    chianItem = 'o';
                }
            } else {
                chianItem = 'o';
            }
            chainStr += chianItem;
        });
        if (chainStr.split('l').length - 1 > MAX_LOGIC_LIMIT) {
            const errData = {
                id: this.currentExp.id,
                errorCode: '20004',
            };
            this.errorData.expressionError = [errData];
            return;
        }
        if (startLogicReg.test(chainStr)) {
            const index = chainStr.indexOf('l');
            const errData = {
                id: this.currentExp.children[index].data.id,
                errorCode: '20001',
            };
            logicError.push(errData);
        }
        if (endLogicReg.test(chainStr)) {
            const conLogicArr = chainStr.split('l');
            const index = chainStr.length - last(conLogicArr).length - 1;
            const errData = {
                id: this.currentExp.children[index].data.id,
                errorCode: '20003',
            };
            logicError.push(errData);
        }
        if (continuousLogicReg.test(chainStr)) {
            const conLogicArr = chainStr.split('l_l');
            let start = 0;
            forEach(conLogicArr, (item) => {
                start += item.length;
                if (start >= this.currentExp.children.length) return;
                forEach([start, start + 2], (subItem) => {
                    const errData = {
                        id: this.currentExp.children[subItem].data.id,
                        errorCode: '20002',
                    };
                    logicError.push(errData);
                });
                start += 3;
            });
        }
        if (logicError.length > 0) {
            this.errorData.tokenError = concat(this.errorData.tokenError || [], logicError);
        }
    },
    /**
    * 验证rangeExp token错误
    * @param {*} rangeTokenList 过滤后的tokenList
    * @param {*} patentField   父表达式字段名
    */
    validateRangeToken(rangeTokenList, patentField) {
        const rangeStart = rangeTokenList[0].data.value;
        const rangeEnd = rangeTokenList[2].data.value;
        const tokenError = [];
        const customFieldDateTypeFields = searchFieldsService.dateTypeFieldList;
        const customFieldNumTypeFields = searchFieldsService.numTypeFieldList;
        if (includes(DATE_TYPE_FIELDS, patentField) || includes(customFieldDateTypeFields, patentField)) {
            // 时间类型
            if (!(rangeStart === '*' || isDateValue(rangeStart))) {
                const errData = {};
                errData.id = rangeTokenList[0].data.id;
                errData.errorCode = '50002';
                tokenError.push(errData);
            }
            if (!(rangeEnd === '*' || isDateValue(rangeEnd))) {
                const errData = {};
                errData.id = rangeTokenList[2].data.id;
                errData.errorCode = '50002';
                tokenError.push(errData);
            }
            if (isDateValue(rangeStart) && isDateValue(rangeEnd) && !isCorrectRange(rangeStart, rangeEnd)) {
                const errData = {};
                errData.id = rangeTokenList[0].data.id;
                errData.errorCode = '50003';
                tokenError.push(errData);
            }
        } else if (includes(RANGE_TYPE_FIELDS, patentField) || includes(customFieldNumTypeFields, patentField)) {
            // 数值类型
            if (!(rangeStart === '*' || (isIntegerValue(rangeStart) && toNumber(rangeStart) >= 0))) {
                const errData = {};
                errData.id = rangeTokenList[0].data.id;
                errData.errorCode = '50004';
                tokenError.push(errData);
            }
            if (!(rangeEnd === '*' || (isIntegerValue(rangeEnd) && toNumber(rangeEnd) >= 0))) {
                const errData = {};
                errData.id = rangeTokenList[2].data.id;
                errData.errorCode = '50004';
                tokenError.push(errData);
            }
            if (isIntegerValue(rangeStart) && isIntegerValue(rangeEnd) && toNumber(rangeStart) > toNumber(rangeEnd)) {
                const errData = {};
                errData.id = rangeTokenList[0].data.id;
                errData.errorCode = '50005';
                tokenError.push(errData);
            }
        } else if (includes(RANGE_CLASSIFICATION_FIELDS, patentField)) {
            if (!isCorrectClassification(rangeStart, patentField)) {
                const errData = {};
                errData.id = rangeTokenList[0].data.id;
                errData.errorCode = '60001';
                tokenError.push(errData);
            }
            if (!isCorrectClassification(rangeEnd, patentField) || (isCorrectClassification(rangeStart, patentField) && !isStartStrSame(rangeStart, rangeEnd))) {
                const errData = {};
                errData.id = rangeTokenList[2].data.id;
                errData.errorCode = '60001';
                tokenError.push(errData);
            }
        }

        if (tokenError.length > 0) {
            this.errorData.tokenError = concat(this.errorData.tokenError || [], tokenError);
        }
    },
    getRangeTokenList(children) {
        const _tokenList = [];
        forEach(children, (item) => {
            const _type = get(item, 'data.type');
            if (_type !== TOKEN_TYPE_SPACE && _type !== TOKEN_TYPE_OPERATOR) {
                _tokenList.push(item);
            }
        });
        return _tokenList;
    },
    getIsFieldNest() {
        const isFieldNest = !!find(this.ExpressionList, {
            expressionType: EXPRESSION_TYPE_FIELD,
        });
        return isFieldNest;
    },
    getIsNotSupportedFieldNest() {
        const item = findLast(this.ExpressionList, {
            expressionType: EXPRESSION_TYPE_FIELD,
        });
        const field = get(item, 'children[0].data.value', '');
        if (item && !SUPPORT_NEST_FIELDS.includes(field.toUpperCase())) {
            return true;
        }
        return false;
    },
    getIsMultipleSpecialQuery(type) {
        const specialQueryTokenLen = filter(this.TokenList, (item) => item.type === type);
        return specialQueryTokenLen && specialQueryTokenLen.length > 1;
    },
    isNotSpecialStart(specialTokenItem) {
        const excludeTypeArr = [TOKEN_TYPE_OPERATOR, TOKEN_TYPE_SPACE];
        const startToken = filter(this.TokenList, (item) => {
            if (item.end <= specialTokenItem.start && !includes(excludeTypeArr, item.type)) {
                return true;
            }
        });
        return startToken && startToken.length > 0;
    },
    isRNotStartOrEnd(specialTokenItem) {
        const excludeTypeArr = [TOKEN_TYPE_OPERATOR, TOKEN_TYPE_SPACE];
        const startToken = filter(this.TokenList, (item) => {
            if (item.end <= specialTokenItem.start && !includes(excludeTypeArr, item.type)) {
                return true;
            }
        });
        return startToken && startToken.length > 0;
    },
    getPlaceSymbolCount(children) {
        let queryStr = '';
        let countArr = [0];
        for (let index = 0; index < children.length; index++) {
            const item = children[index];
            const value = get(item, 'data.value');
            const expressionValue = get(item, 'value');
            //   const type = get(item, 'data.type');
            const expressionType = get(item, 'expressionType');
            const prev2Type = get(children[index - 2], 'data.type');
            //   const nextType = get(children[index + 1], 'data.type');
            const next2Type = get(children[index + 2], 'data.type');
            //   如果子表达式用已经存在错误，父表达式不在提示错误
            if (expressionType !== EXPRESSION_TYPE_TOKEN && expressionType !== EXPRESSION_TYPE_RANGE) {
                const error = _getPlaceSymbolError(item);
                if (error) {
                    queryStr = '';
                    countArr = [0];
                    break;
                }
            }
            /**
         * 结束placeSymbol的标志
         * 1、出现逻辑词
         * 2、默认补逻辑词的空格 例如 car bus 中间默认会被补逻辑词
         */
            if (next2Type === TOKEN_TYPE_PLACESYMBOL || queryStr) {
                queryStr += (value || expressionValue);
            }
            if (queryStr && next2Type !== TOKEN_TYPE_PLACESYMBOL && prev2Type === TOKEN_TYPE_PLACESYMBOL) {
                const psCount = _getplacesymbolCount(queryStr);
                if (psCount) {
                    countArr.push(psCount);
                }
                queryStr = '';
            }
        }
        return max(countArr);
    },
};

let TokenHandler = null;
function _getplacesymbolCount(queryStr) {
    // 先通过正则匹配错略的个数，再通过token进行精确计算
    const psReg = /\$(W(\d+|S))|(PRE\d+)/ig;
    const psArr = queryStr.match(psReg);
    if (psArr && psArr.length > MAX_PLACE_SYMBOL_LIMIT) {
        if (!TokenHandler) {
            TokenHandler = new Token(this.isRDVersion);
        }
        const tokenList = TokenHandler.getTokenList(queryStr);
        const placesymbolList = filter(tokenList, (tokenItem) => tokenItem.type === TOKEN_TYPE_PLACESYMBOL);
        return placesymbolList.length;
    }
}

function _getPlaceSymbolError(expressionTree) {
    let hasPlaceSymbolError = false;
    getErrorDataArr(expressionTree);

    // eslint-disable-next-line no-shadow
    function getErrorDataArr(expressionTree) {
        const errorData = get(expressionTree, 'errorData.expressionError');
        if (errorData && errorData.length) {
            hasPlaceSymbolError = !!find(errorData, {
                errorCode: '40003',
            });
        }
        if (expressionTree.children && !hasPlaceSymbolError) {
            forEach(expressionTree.children, (item) => {
                getErrorDataArr(item);
            });
        }
    }
    return hasPlaceSymbolError;
}
